<template>
  <div>
    <div v-if="!userDetailItems" class="example3">
      <a-spin />
    </div>
    <fo-layout v-else>
      <div class="industries-dtl">
        <p class="pages-return-btn">
          <span @click="$router.push('/practice/industries')"><a-icon type="left" /> Back</span>
        </p>
        <a-row :gutter="50">
          <a-col :sm="16">
            <div class="content-layout">
              <h1 class="title">{{userDetailItems.industry_title_zh}}</h1>
              <div class="content-html">
                <img :src="userDetailItems.industry_poster_url" width="100%" alt="">
                <br />
                <br />
                <div style="white-space:pre-wrap;" v-html="userDetailItems.industry_content"></div>
              </div>
            </div>
          </a-col>
          <a-col :sm="8">
            <div class="card-other-industry">
              <div class="title">Other Industry</div>
              <fo-nodata v-if="!userItems.length"></fo-nodata>
              <template v-for="(item, index) in userItems">
                <div class="card-item" :key="index" v-if="index < 3">
                  <cardOtherIndustry
                    :imgurl="item.industry_poster_url"
                    :title="item.industry_title_zh"
                    @click="routerclick(item.code)">
                  </cardOtherIndustry>
                </div>
              </template>
            </div>
          </a-col>
        </a-row>
        <div class="cases-layout" v-if="caseItems.length > 0">
          <h1 class="title">Related Cases</h1>
          <a-row :gutter="50">
            <a-col :sm="8" v-for="(item, index) in caseItems" :key="index">
              <div class="pb-50">
                <cardCase
                  :imgurl="item.case_poster_url"
                  :title="item.case_title"
                  :industries="item.case_industry_title_zh"
                  :areas="item.case_business_title_zh"
                  @click="goToPage('../cases/' + item.code)">
                </cardCase>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </fo-layout>
  </div>
</template>

<script>
import cardCase from './comps/cardCases.vue'
import cardOtherIndustry from './comps/cardIndustriesB.vue'
export default {
  components: {
    cardCase,
    cardOtherIndustry
  },
  data () {
    return {
      // 行业详情数据
      userDetailItems: {},
      // 案例数据
      caseItems: [],
      // 读取案例请求参数
      readCaseCond: {
        page_num: '1',
        page_size: '10',
        case_industry_id: ''
      },
      // 行业数组
      userItems: [],
      // 读取行业列表请求参数
      readUserCond: {
        page_num: '1',
        page_size: '10'
      }
    }
  },
  watch: {
    '$route.params.param' () {
      this.readUserDetail()
      this.readUsers()
    }
  },
  mounted () {
    this.readUserDetail()
    this.readUsers()
  },
  methods: {
    /*
    * 读取行业详情列表
    */
    readUserDetail () {
      this.get({
        url: 'industryFind',
        data: {
          code: this.$route.params.param
        }
      }, (r) => {
        if (r.code) {
          this.userDetailItems = r.data
          this.readCaseCond.case_industry_id = r.data.id
          this.readCase()
        } else {
          this.error(r.msg)
        }
      })
    },
    routerclick (e) {
      this.$router.push('./' + e)
      this.caseItems = []
      this.readUserDetail()
    },
    /*
    * 读取其他行业列表
    */
    readUsers () {
      this.get({
        url: 'industryRead',
        data: this.readUserCond
      }, (r) => {
        if (r.code) {
          this.userItems = r.data.items.filter(item => item.code !== this.$route.params.param)
        } else {
          this.error(r.msg)
        }
      })
    },
    /*
    * 读取案例详情列表
    */
    readCase () {
      this.get({
        url: 'casesRead',
        data: this.readCaseCond
      }, (r) => {
        if (r.code) {
          this.caseItems = !r.data ? [] : r.data.items
        } else {
          this.error(r.msg)
        }
      })
    },
    // 跳转详情
    goToPage (router) {
      window.scroll(0, 0)
      this.$router.push(router)
    }
  }
}
</script>

<style lang="less">
  @import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  .industries-dtl {
    .cases-layout,
    .content-layout {
      .title {
        height: 60px;
        font-weight: bold;
        font-family: Georgia, 宋体;
        margin-bottom: 30px;
        border-bottom: 1px solid @graydark;
      }
    }
    .cases-layout {
      padding-top: 30px;
    }
    .card-other-industry {
      .title {
        height: 60px;
        margin-bottom: 30px;
        border-bottom: 1px solid @graydark;
        padding-top: 10px;
        color: @silver;
        text-align: left;
        margin-top: 30px;
        font-size: 16px;
      }
      .card-item {
        padding-bottom: 30px;
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  .industries-dtl {
    .cases-layout,
    .content-layout {
      .title {
        height: 60px;
        font-weight: bold;
        font-family: Georgia, 宋体;
        margin-bottom: 30px;
        border-bottom: 1px solid @graydark;
      }
    }
    .cases-layout {
      padding-top: 30px;
    }
    .card-other-industry {
      .title {
        height: 60px;
        margin-bottom: 30px;
        border-bottom: 1px solid @graydark;
        text-align: center;
        padding-top: 10px;
        color: @silver;
        font-size: 16px;
      }
      .card-item {
        padding-bottom: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/industriesDtl.vue